import React from 'react'
import {
  CustomersStyled,
  CustomersText,
  CustomersTextCheq,
  CustomersTextWrapper,
} from './Customers.styled'
import { Trans } from 'react-i18next'

import CustomersImg from 'Assets/images/customers.svg'
import CustomersMobileImg from 'Assets/images/CustomersMobile.svg'
import { isMobile } from 'react-device-detect'

export const Customers = () => {
  return (
    <CustomersStyled>
      <CustomersTextWrapper>
        <CustomersText>
          <Trans ns="pricing" i18nKey="customers_text">
            +15,000 advertisers are protecting millions of campaigns using
            <CustomersTextCheq>CHEQ</CustomersTextCheq>
          </Trans>
        </CustomersText>
      </CustomersTextWrapper>
      {isMobile ? (
        <img src={CustomersMobileImg} alt="customers" />
      ) : (
        <img src={CustomersImg} alt="customers" />
      )}
    </CustomersStyled>
  )
}
